import { useEffect, useState } from 'react';

const DEFAULT_DELAY = 200; // ms;

export const useDebouncedValue = <T>(
  value: T,
  delay: number = DEFAULT_DELAY,
): T => {
  const [debounced, setDebounced] = useState<T>(value);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounced(value);
    }, delay);
    return () => {
      clearTimeout(timeout);
    };
  }, [value, delay]);
  return debounced;
};
